/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
  AssistantDetailApiV1AssistantAssistantIdGetPathParams,
  AssistantDetailApiV1AssistantAssistantIdGetQueryParams,
  AssistantDetailApiV1AssistantAssistantIdGetHeaderParams,
  AssistantDetailApiV1AssistantAssistantIdGet422,
} from '../../types/AssistantDetailApiV1AssistantAssistantIdGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const assistantDetailApiV1AssistantAssistantIdGetQueryKey = (
  assistant_id: AssistantDetailApiV1AssistantAssistantIdGetPathParams['assistant_id'],
  params?: AssistantDetailApiV1AssistantAssistantIdGetQueryParams,
) => [{ url: '/api/v1/assistant/:assistant_id', params: { assistant_id: assistant_id } }, ...(params ? [params] : [])] as const

export type AssistantDetailApiV1AssistantAssistantIdGetQueryKey = ReturnType<typeof assistantDetailApiV1AssistantAssistantIdGetQueryKey>

/**
 * @summary Assistant Detail
 * {@link /api/v1/assistant/:assistant_id}
 */
export async function assistantDetailApiV1AssistantAssistantIdGet(
  assistant_id: AssistantDetailApiV1AssistantAssistantIdGetPathParams['assistant_id'],
  params?: AssistantDetailApiV1AssistantAssistantIdGetQueryParams,
  headers?: AssistantDetailApiV1AssistantAssistantIdGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
    ResponseErrorConfig<AssistantDetailApiV1AssistantAssistantIdGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/assistant/${assistant_id}`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function assistantDetailApiV1AssistantAssistantIdGetQueryOptions(
  assistant_id: AssistantDetailApiV1AssistantAssistantIdGetPathParams['assistant_id'],
  params?: AssistantDetailApiV1AssistantAssistantIdGetQueryParams,
  headers?: AssistantDetailApiV1AssistantAssistantIdGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = assistantDetailApiV1AssistantAssistantIdGetQueryKey(assistant_id, params)
  return queryOptions<
    AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
    ResponseErrorConfig<AssistantDetailApiV1AssistantAssistantIdGet422>,
    AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
    typeof queryKey
  >({
    enabled: !!assistant_id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return assistantDetailApiV1AssistantAssistantIdGet(assistant_id, params, headers, config)
    },
  })
}

/**
 * @summary Assistant Detail
 * {@link /api/v1/assistant/:assistant_id}
 */
export function useAssistantDetailApiV1AssistantAssistantIdGet<
  TData = AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
  TQueryData = AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
  TQueryKey extends QueryKey = AssistantDetailApiV1AssistantAssistantIdGetQueryKey,
>(
  assistant_id: AssistantDetailApiV1AssistantAssistantIdGetPathParams['assistant_id'],
  params?: AssistantDetailApiV1AssistantAssistantIdGetQueryParams,
  headers?: AssistantDetailApiV1AssistantAssistantIdGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        AssistantDetailApiV1AssistantAssistantIdGetQueryResponse,
        ResponseErrorConfig<AssistantDetailApiV1AssistantAssistantIdGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? assistantDetailApiV1AssistantAssistantIdGetQueryKey(assistant_id, params)

  const query = useQuery(
    {
      ...assistantDetailApiV1AssistantAssistantIdGetQueryOptions(assistant_id, params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<AssistantDetailApiV1AssistantAssistantIdGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}